module.exports = __webpack_public_path__ + "img/3_02 (2).e278e93e.jpg";